import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";

type Props = {
  src: string;
  name: string;
  count: number;
};

export default function FactionWarehouseCard({ src, name, count }: Props) {
  const { t } = useTranslation("faction");

  return (
    <div className="relative flex items-end h-[9.5rem] py-3.5 px-2.5 bg-dark-800 rounded-2xl">
      <div
        className="absolute top-2.5 left-5 w-[calc(100%-2.5rem)] h-20 bg-contain bg-no-repeat bg-center"
        style={{ backgroundImage: `url(${src})` }}
      />
      <div>
        <p className="mb-1.5 text-13 font-bold">{name}</p>
        <p className="text-12 font-medium text-white/70">
          {formatPrice(count)} {t("faction.cnt")}.
        </p>
      </div>
    </div>
  );
}
